import {TableColumnsType} from 'antd';
import {styled} from 'styled-components';
import {DiffRevenueInfo} from './DiffRevenueInfo';
import {flexMixin} from '../../../../../styles/mixins';
import {ITableLike4Like} from '../../../../../entities/reports';
import {formatNumberWithDot} from '../../../../../utils/functions/formatNumberWithDot';

export const createLike4LekeColumns = (): TableColumnsType<ITableLike4Like> => [
    {
        title: 'Ресторан(ы)',
        dataIndex: 'key',
        width: 'auto',
        align: 'left',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
        title: 'Продажи',
        dataIndex: 'Продажи',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',
        width: '20%',
        render: (value) => <StyledSum>{formatNumberWithDot(value)}</StyledSum>,
    },
    {
        title: 'Кол-во чеков',
        dataIndex: 'Кол-во чеков',
        align: 'right',
        width: '20%',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        render: (value) => <StyledSum>{`${value} шт`}</StyledSum>,
    },

    {
        title: 'Средний чек',
        dataIndex: 'Средний чек',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',
        width: '20%',
        render: (value) => <StyledSum>{formatNumberWithDot(value)}</StyledSum>,
    },

    {
        title: 'Динамика',
        dataIndex: 'Динамика',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',
        width: '20%',
        render: (value) => (
            <DiffWrapper>
                <DiffRevenueInfo diff={value} />
            </DiffWrapper>
        ),
    },
];

const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;

const DiffWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'flex-end', 'center')};
    padding-right: 0.5em;
`;
